import TextField from '@mui/material/TextField';

export const NumberInput = ({value, label, onChange}) => (
    <TextField
        size="small"
        fullWidth
        value={value}
        type="number"
        label={label}
        onChange={({target}) => onChange(target.value ? +target.value : target.value)}
        required
        sx={{mb: 1, mt: 1}}
    />
);
